import config from '../services/config';

export default (): void => {
    const partnerHubUrl = config.partnerHubUrl;
    window.location.assign(partnerHubUrl);
};
